/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
export const CHART_TYPE = "CHART";
export const COLUMN_TYPE = "COLUMN";
export const DASHBOARD_HEADER_TYPE = "HEADER";
export const DASHBOARD_GRID_TYPE = "GRID";
export const DASHBOARD_ROOT_TYPE = "ROOT";
export const DIVIDER_TYPE = "DIVIDER";
export const HEADER_TYPE = "HEADER";
export const MARKDOWN_TYPE = "MARKDOWN";
export const NEW_COMPONENT_SOURCE_TYPE = "NEW_COMPONENT_SOURCE";
export const ROW_TYPE = "ROW";
export const TABS_TYPE = "TABS";
export const TAB_TYPE = "TAB";
// Dynamic type proposes lazy loading of custom dashboard components that can be added in separate repository
export const DYNAMIC_TYPE = "DYNAMIC";

export default {
    CHART_TYPE,
    COLUMN_TYPE,
    DASHBOARD_HEADER_TYPE,
    DASHBOARD_GRID_TYPE,
    DASHBOARD_ROOT_TYPE,
    DIVIDER_TYPE,
    HEADER_TYPE,
    MARKDOWN_TYPE,
    NEW_COMPONENT_SOURCE_TYPE,
    ROW_TYPE,
    TABS_TYPE,
    TAB_TYPE,
    DYNAMIC_TYPE,
};
